<div class="toast-container" [ngClass]="{'success': toastPackage.toastType === 'toast-success', 'error': toastPackage.toastType === 'toast-error'}" >
  <div class="toast-message">{{ message }}</div>
</div>